import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Box,
  Menu,
  IconButton,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function DateDropdown() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (event: any) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event: any) => {
    setEndDate(event.target.value);
  };

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpenUserMenu}
        sx={{ fontSize: "18px", borderRadius: "5px" }}
        color='inherit'
      >
        Today <ExpandMoreIcon />
      </IconButton>
      <Menu
        sx={{ mt: "45px" }}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Box sx={{ textAlign: "center", py: "12px" }}>Date</Box>
        <MenuItem>
          <TextField
            InputLabelProps={{ shrink: true }}
            type='date'
            label='Start Date'
            value={startDate}
            onChange={handleStartDateChange}
            fullWidth
          />
        </MenuItem>
        <MenuItem>
          <TextField
            type='date'
            label='End Date'
            value={endDate}
            onChange={handleEndDateChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
